import React from "react";


export function TruncatedTitle({ title, maxLength = 35, className = "library-card-title" }) {
  const displayTitle = title || 'Untitled';
  const needsTruncation = displayTitle.length > maxLength;

  return (
    <div className={`${className} ${needsTruncation ? 'title-truncated' : ''}`}>
      <span className="title-text">{needsTruncation ? displayTitle.slice(0, maxLength) : displayTitle}</span>
      {needsTruncation && <span className="title-fade" />}
    </div>
  );
}


export function ToggleSwitch({ checked, onChange, label, disabled }) {
  return (
    <label className={`toggle-switch-container ${disabled ? 'disabled' : ''}`}>
      <span className="toggle-label">{label}</span>
      <div className={`toggle-switch ${checked ? 'toggle-on' : ''} ${disabled ? 'toggle-disabled' : ''}`} onClick={() => !disabled && onChange(!checked)}>
        <div className="toggle-thumb" />
      </div>
    </label>
  );
}
